import { useEffect, useState } from "react";
import { api, CallLog } from "../lib/api";

export function CallsPage({ csrf }: { csrf: string }) {
  const [calls, setCalls] = useState<CallLog[]>([]);
  const [selected, setSelected] = useState<string[]>([]);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  function load() {
    api
      .listCalls()
      .then((r) => {
        setCalls(r.calls);
        setSelected((prev) => prev.filter((id) => r.calls.some((call) => call.id === id)));
      })
      .catch((e) => setError(e.message));
  }

  useEffect(() => {
    load();
  }, []);

  async function deleteOne(call: CallLog) {
    if (!window.confirm("Delete this call log?\n\nThis will remove the call from your visible call history.")) return;
    setBusy(true);
    setError("");
    setMsg("");
    try {
      await api.deleteCall(call.id, csrf);
      setMsg("Call log deleted.");
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Delete failed");
    } finally {
      setBusy(false);
    }
  }

  async function deleteSelected() {
    if (!selected.length) return;
    if (!window.confirm(`Delete ${selected.length} selected call logs?\n\nThis will remove them from your visible call history.`)) return;
    setBusy(true);
    setError("");
    setMsg("");
    try {
      await api.deleteCalls(selected, csrf);
      setMsg(`${selected.length} call logs deleted.`);
      setSelected([]);
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Delete failed");
    } finally {
      setBusy(false);
    }
  }

  function toggle(id: string, checked: boolean) {
    setSelected((prev) => checked ? [...new Set([...prev, id])] : prev.filter((item) => item !== id));
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Call logs</h1>
          <p>Outbound attempt history with delivery status for AI voice messages.</p>
        </div>
        <div className="row-actions">
          <button className="btn danger" type="button" disabled={busy || selected.length === 0} onClick={deleteSelected}>
            Delete selected
          </button>
        </div>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      {msg ? <div className="alert success">{msg}</div> : null}
      <div className="card">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Phone</th>
              <th>Status</th>
              <th>Provider</th>
              <th>Message</th>
              <th>Duration</th>
              <th>When</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {calls.map((c) => (
              <tr key={c.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selected.includes(c.id)}
                    onChange={(e) => toggle(c.id, e.target.checked)}
                    aria-label={`Select call ${c.id}`}
                  />
                </td>
                <td className="mono">{c.phone}</td>
                <td>
                  <span className={`badge ${c.status}`}>{c.status}</span>
                </td>
                <td>{c.provider}</td>
                <td>{c.messageDelivered ? "delivered" : "—"}</td>
                <td>{c.durationSec ?? 0}s</td>
                <td className="muted">{new Date(c.createdAt).toLocaleString()}</td>
                <td>
                  <button className="btn sm danger" type="button" disabled={busy} onClick={() => deleteOne(c)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
